import React, { useEffect, useState } from "react";

import { useBreakpoint } from "../../hooks";
import SiteIcon from "../../images/icons/site-suggest-world.inline.svg";
import { appFormSlug } from "../../utils/sharedDatasets";
import CtaButton from "../shared/buttons/ctaButton";

const targetSiteDesc = Object.freeze({
  za: "GVI ZA",
  us: "GVI US",
  ca: "GVI CA",
  au: "GVI AU",
  gb: "GVI UK",
  eu: "GVI IE"
});

const targetSiteDomain = Object.freeze({
  za: "gviafrica.co.za",
  us: "gviusa.com",
  ca: "gvicanada.ca",
  au: "gviaustralia.com.au",
  gb: "gvi.co.uk",
  eu: "gvi.ie"
});

const FloatingSiteSuggest = ({ suggestStatus = false }) => {
  const breakpoint = useBreakpoint();

  const currentSiteBrand =
    process.env.GATSBY_DEFAULT_THEME?.toLocaleLowerCase();
  const [showFloatingSiteSuggest, setFloatingSiteSuggest] = useState(false);

  const [closeFloatingSiteSuggest, setCloseFloatingSiteSuggest] =
    useState(false);

  const [currentLocation, setCurrentLocation] = useState("/");
  const [getSuggestedDesc, setSuggestedDesc] = useState("");
  const [isForm, setFormPage] = useState(false);

  const handleFloatingSiteSuggest = () => {
    setCloseFloatingSiteSuggest(true);
    suggestStatus(false);

    if (typeof window !== "undefined") {
      const getConfig = JSON.parse(
        window.localStorage.getItem("promo_config") || "{}"
      );

      window.localStorage.setItem(
        "promo_config",
        JSON.stringify({
          ...getConfig,
          site_suggestion: "hide"
        })
      );
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const url = new URL(window.location);

      const currentPath = url.pathname ?? "";

      const path = currentPath.split("/").filter((slug) => slug.trim() !== "");
      const lastSegment = path[path.length - 1];

      const userDetailsRaw =
        window.localStorage.getItem("gvx-analytics") || "{}";

      const userDetails = JSON.parse(userDetailsRaw);

      const promoConfig = JSON.parse(
        window.localStorage.getItem("promo_config") || "{}"
      );

      const showBannerFlag =
        !isForm &&
        !closeFloatingSiteSuggest &&
        promoConfig?.site_suggestion === "show";

      suggestStatus(showBannerFlag);
      setFloatingSiteSuggest(showBannerFlag);

      const getCurrentBrand = currentSiteBrand.includes("light")
        ? "people."
        : "www.";

      const getTargetSiteDomain = [
        "https://",
        getCurrentBrand,
        targetSiteDomain[
          userDetails.suggest_country?.toLocaleLowerCase() ?? "gb"
        ],
        url.pathname
      ]
        .filter(Boolean)
        .join("");

      setCurrentLocation(getTargetSiteDomain);

      const suggestedDesc =
        targetSiteDesc[
          userDetails.suggest_country
            ? userDetails.suggest_country?.toLocaleLowerCase()
            : "gb"
        ];

      setFormPage(appFormSlug.includes(lastSegment));
      setSuggestedDesc(suggestedDesc);
    }
  });

  // console.log("item statuses", {
  //   closeFloatingSiteSuggest,
  //   isForm,
  //   showFloatingSiteSuggest
  // });

  if (!isForm && !closeFloatingSiteSuggest && showFloatingSiteSuggest) {
    return (
      <div className="w-full bg-black-lighter planet:bg-white py-2 sm:py-1 items-center justify-center flex flex-col sm:flex-row">
        <div className="flex items-center justify-center gap-x-1 sm:gap-x-3">
          <div className="w-4 h-4 sm:w-6 sm:h-6 ">
            <SiteIcon className="w-full h-full fill-white planet:fill-gray-darker" />
          </div>
          <div className="flex flex-row sm:flex-row gap-x-1 text-sm sm:text-base items-center text-white planet:text-gray-darker">
            <div
              className="text-center flex flex-row gap-x-1"
              dangerouslySetInnerHTML={{
                __html: [
                  `<span class="hidden sm:block">According to your location, </span>`,
                  `<span class="font-bold">`,
                  getSuggestedDesc,
                  `</span>`,
                  " would be more appropriate."
                ].join("")
              }}
            ></div>
          </div>
        </div>
        <div className="flex items-center justify-center sm:gap-x-3 sm:px-3">
          <CtaButton
            preset={
              breakpoint === "xs"
                ? "base"
                : currentSiteBrand.includes("light")
                  ? "senary"
                  : "secondary"
            }
            showArrowIcon={breakpoint !== "xs"}
            to={currentLocation}
            ctaLabel="Take me there!"
            extraButtonStyle="xxxs:border-0 sm:border xxxs:py-0 sm:py-2 sm:px-4 planet:xxxs:text-gray-darker planet:sm:text-white"
            labelClass={[
              currentSiteBrand.includes("light")
                ? "text-white sm:text-black-lighter"
                : "",
              "text-sm sm:text-base sm:px-4 underline underline-offset-4 font-bold sm:no-underline"
            ]
              .filter(Boolean)
              .join(" ")}
          />
          <CtaButton
            preset={"base"}
            onClick={handleFloatingSiteSuggest}
            ctaLabel="No, thanks"
            extraButtonStyle="xxxs:border-0 xxxs:py-0 sm:py-2"
            labelClass="text-sm sm:text-base underline underline-offset-4 font-normal sm:font-bold text-white planet:text-gray-darker"
            showAsButton={true}
          />
        </div>
      </div>
    );
  }
};

export default FloatingSiteSuggest;
